<div
  class="min-h-screen bg-center bg-cover kiosk:pb-40"
  [ngClass]="kioskDisplay ? 'flex flex-col gap-5' : ''"
  [style.backgroundColor]="backgroundColor | contentBuilderColor: '#FFFFFF'"
  [style.backgroundImage]="backgroundImage ? 'url(' + backgroundImage.url + ')' : 'initial'"
>
  <app-block-list [blockIdList]="body"></app-block-list>
</div>
<app-block-list [blockIdList]="footer"></app-block-list>
